module.exports = __webpack_public_path__ + "img/box.904c1eaa.png";